<template>
  <section>
    <quill-editor v-model="content" :ref="myQuillEditor" :options="editorOption" @input="onEditorChange($event)">
    </quill-editor>
    <span class="wordNumber">{{ TiLength }}/6000</span>

    <el-dialog title="图片上传" :visible.sync="SavaAsFlowVisible" v-model="SavaAsFlowVisible" :before-close="handleClose"
      width="50%">
      <component v-bind:is="Imagecomponent" :show="ImageFileshow" :value="imgList" :imgLimit="imgLimit"
        :isMultiple="true" @change="ImageChange"></component>
      <span
        style="font-size: 10px !important;color: #b1aaaa;">备注：图片大小不超过15MB，支持jpg、png和bmp，gif等格式</span>
      <el-button style="margin-top: 2%; margin-left: 70%" size="small" type="primary" plain :loading="imageloading"
        @click="admitImg">确定</el-button>
    </el-dialog>
  </section>
</template> 
<script>
import ImageFile from "./ImageFile.vue";
import { FilesCreates } from "../../api/api";
export default {
  name: "myEditor",
  components: {
    ImageFile
  },
  props: {
    //默认内容
    value: {
      type: String,
      default: "",
    },
    myQuillEditor: {
      type: String,
      default: "myQuillEditor",
    },
  },
  data() {
    let _this = this;
    return {
      //图片上传帮助组件
      ImageFileshow: false,
      imgList: [],
      imgLimit: 30,
      SavaAsFlowVisible: false, //图片隐藏或显示
      imageloading: false,

      videosshow: false, //视频上传帮助组件
      pathAddress: "", //视频地址
      videoType: 1, //上传的类型，默认为地址类型
      files: [], //视频文件
      videoVisible: false, //视频弹窗隐藏显示

      Imagecomponent: "ImageFile",

      content: this.value,
      editorOption: {
        placeholder: "请输入内容...",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"], //加粗、斜体、下划线、删除线, 'strike'
            ["blockquote", "code-block"], //引用、代码块
            [{ header: 1 }, { header: 2 }], //H1 H2
            [{ list: "ordered" }, { list: "bullet" }], //列表
            [{ script: "sub" }, { script: "super" }], //上标、下标
            [{ indent: "-1" }, { indent: "+1" }], //缩进
            [{ direction: "rtl" }], //文字编辑方向，从左到右还是从右到左
            [{ size: ["small", false, "large", "huge"] }], //文字大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], //选中的文字容器高度
            [{ font: [] }], //字体样式
            [{ color: [] }, { background: [] }], //颜色、背景颜色
            [{ align: [] }], //对齐方式
            ["clean"], //清除选中文字的所有样式
            ["link", "image"], // 链接、图片、视频
          ],
        },
      },

      status: "success",
      TiLength: 0,
      flag: true, // 初始化富文本
      videoRandom: "",//随机数触发组件
    };
  },
  mounted: function () {
    // this.content = this.value;
    if (this.$refs[this.myQuillEditor]) {
      //myQuillEditor改成自己的
      this.$refs[this.myQuillEditor].quill
        .getModule("toolbar")
        .addHandler("image", this.imgHandler);
    }
  },
  methods: {
    imgHandler(state) {
      if (state) {
        //触发input的单击 ，fileBtn换成自己的
        this.ImageFileshow = true;
        this.SavaAsFlowVisible = true;
      }
    },
    onEditorBlur() {
      //失去焦点事件
      // console.log('失去焦点');
    },
    onEditorFocus() {
      //获得焦点事件
      // console.log('获得焦点事件');
    },
    onEditorChange(val) {
      // console.log('内容改变事件');
      //debugger
      let quill = this.$refs[this.myQuillEditor].quill;
      if (val) {
        let len = quill.getLength() - 1;
        if (len > 6000) {
          quill.deleteText(6000, len - 6000);
        }
      } else {
        this.TiLength = 0;
      }
      this.TiLength = quill.getLength() - 1;
      this.$emit("change", this.content); // 触发事件，将富文本框中的值传递出去
    },
    //图片弹窗关闭事件
    handleClose(done) {
      done();
    },
    //视频弹窗关闭事件
    videoClose(done) {
      done();
    },
    //选择图片后的回调
    ImageChange(val) {
      console.log(val);
      this.imgList = val;
    },
    //提交图片
    async admitImg() {
      const formData = new FormData();
      if (this.imgList) {
        let imgFil = this.imgList.filter((s) => s.status == "ready");
        if (imgFil != null) {
          imgFil.forEach((it, index) => {
            formData.append("files", it.raw);
          });
          //debugger;
          this.imageloading = true;
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          await FilesCreates(formData, config).then((res) => {
            this.imgList = []; //清空数据
            this.imageloading = false;
            if (res.data.success) {
              let data = res.data.response;
              if (data) {
                console.log(data);
                let quill = this.$refs[this.myQuillEditor].quill;
                console.log(quill);
                data.forEach((it, index) => {
                  //这里就是返回的图片地址，如果接口返回的不是可以访问的地址，要自己拼接
                  let imgUrl = it;
                  imgUrl = imgUrl.replace(/\\/g, "/");
                  let length = quill.selection.savedRange.index; //获取坐标位置
                  quill.insertEmbed(length, "image", imgUrl); //插入图片
                  quill.setSelection(quill.selection.savedRange.index + 1); //插入完成后，光标往后移动一位
                });
                this.SavaAsFlowVisible = false;
              }
            }
          });
        }
      } else {
        this.$message({
          message: "找不到文件无法提交",
          type: "error",
        });
      }
    }
  },
  watch: {
    value: function (newval) {
      this.content = newval;
    },
  },
  computed: {
    editor() {
      return this.$refs[this.myQuillEditor].quill;
    },
  },
};
</script> 

<style scoped>
.wordNumber {
  position: absolute;
  right: 13px;
  bottom: 15px;
  color: #666666;
  font-size: 14px;
}
</style>

